import { useState } from "react";
// import { ReactComponent as ArrowDownIcon } from "../../../../assets/Icons/Universal/ArrowDown.svg";
import "../../../../styles/ComponentsStyles/Setting/Permission/PermissionChangeBtn.style.css";
const PermissionChangeBtn = () => {
  const [buttonTxt, setButtonTxt] = useState("Active");
  return (
    <div>
      <select
        name="change"
        onChange={(e) => setButtonTxt(e.target.value)}
        className="permissionChangeBtn"
        id={"permissionChangeBtnId"}
        style={{backgroundColor:buttonTxt==="Inactive"?"var(--deepOrange1)":"var(--successGreen)"}}
      >
        <option value="Active">Active</option>
        <option value="Inactive">Inactive</option>
      </select>
    </div>
  );
};

export default PermissionChangeBtn;
